import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../config/firebase';

const manageKey = httpsCallable(getFunctions(app, 'us-central1'), 'suiteApiKey');
export const getApiKeyStatus = async (provider = 'openai') => (await manageKey({ action: 'status', provider })).data;
export const saveApiKey = async (apiKey, provider = 'openai') => (await manageKey({ action: 'save', apiKey, provider })).data;
export const removeApiKey = async (provider = 'openai') => (await manageKey({ action: 'remove', provider })).data;

export function profileErrorMessage(error) {
  if (error.code === 'functions/not-found' || error.code === 'functions/unavailable') {
    return 'Profile services are unavailable. Please try again later.';
  }
  return error.code?.startsWith('functions/') ? error.message : 'Your API key could not be updated. Please try again.';
}
